module.exports = __webpack_public_path__ + "img/Butterfly_00069.5f515de7.png";